import { render, staticRenderFns } from "./AllowEmailRequiredDrawer.vue?vue&type=template&id=9723f88e&scoped=true&"
import script from "./AllowEmailRequiredDrawer.vue?vue&type=script&lang=js&"
export * from "./AllowEmailRequiredDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AllowEmailRequiredDrawer.vue?vue&type=style&index=0&id=9723f88e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9723f88e",
  null
  
)

export default component.exports